function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F5F5F5"
}, /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#434957",
  d: "M44.357 17.986l-4.45-3.106V2.504a1.464 1.464 0 0 0-.418-1.078A1.424 1.424 0 0 0 38.425 1h-30.9c-.818 0-1.482.673-1.482 1.503V14.88l-4.4 3.106c-.399.267-.64.718-.643 1.202v28.309C1 48.327 1.664 49 2.483 49h41.034c.819 0 1.483-.673 1.483-1.503V19.188a1.458 1.458 0 0 0-.643-1.202zm-4.45.551l1.484 1.002-1.483 1.804v-2.806zM9.01 4.007h27.933V24.95l-6.724 8.217-6.23-5.812a1.469 1.469 0 0 0-1.977 0l-5.982 5.612-7.02-8.217V4.007zm-2.966 14.53v2.706l-1.434-1.704 1.434-1.002zm-2.077 4.86l9.888 11.624-9.888 9.27V23.396zm2.522 22.597L23 30.512l16.512 15.482H6.488zm35.546-1.704l-9.64-9.068 9.64-11.725V44.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#3D84FF",
  strokeWidth: 1.2,
  d: "M21.256 23L15 16.497l2.784-2.89 3.477 3.61L28.216 10 31 12.891z"
}));

const SvgIcEmailVerify = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEmailVerify, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-email-verify.2de75f21.svg";
export { ForwardRef as ReactComponent };